import React, { useCallback, useMemo } from 'react';
import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import { CultureIndexCulture } from 'types/Meteorology/Agro/CultureIndex/culture';
import useCultures from 'hooks/Meteorology/Agro/CultureIndex/Location/useCultures';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

export default function Culture() {
  const {
    cultures,
    selectedCulture,
    setCulture,
  } = useCultures();
  const closeAccordion = useMemo(
    () => buildAccordionClickFunction('culture-index-location-culture'),
    [],
  );
  const setCultureAndClose = useCallback((culture: CultureIndexCulture) => {
    setCulture(culture);
    closeAccordion();
  }, [setCulture, closeAccordion]);

  return (
    <Accordion.Item eventKey="culture" id="culture-index-location-culture">
      <Accordion.Header>Cultura</Accordion.Header>
      <Accordion.Body>
        {cultures.map((culture) => (
          <RadioButton
            className="my-2"
            key={culture.name}
            label={culture.label}
            checked={selectedCulture?.name === culture.name}
            onChange={() => setCultureAndClose(culture)}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
